const comparePopupsByDocumentPosition = (a, b) => {
  if (a.pageIdx === b.pageIdx) {
    if (a.y === b.y) {
      return (a.x - b.x);
    }
    return (a.y - b.y);
  }
  return (a.pageIdx - b.pageIdx);
};

export default comparePopupsByDocumentPosition;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/comparePopupsByDocumentPosition.jsx